exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".app-loading[data-v-7cde209e]{position:fixed;display:flex;justify-content:center;align-items:center;top:0;left:0;width:100vw;height:100vh}.app-spinner[data-v-7cde209e]{opacity:0.5}\n", ""]);
